import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import FullScreenLoader from "./components/misc/FullscreenLoader";
import { useAppContext } from "./contexts/AppContext";
import { useAuth } from "./contexts/AuthContext";

export const PrivateRoute: React.FC = () => {
  const { user, authChecked, mfaRequired } = useAuth();
  const { isLoading } = useAppContext();

  console.info("PrivateRoute component mounted");
  console.info("PrivateRoute authChecked:", authChecked);
  console.info("PrivateRoute user:", user);
  console.info("PrivateRoute mfaRequired:", mfaRequired);

  if (!authChecked || isLoading) {
    return <FullScreenLoader />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (mfaRequired) {
    return <Navigate to="/auth/mfa" replace />;
  }

  return <Outlet />;
};

export const PublicRoute: React.FC = () => {
  const { user, authChecked, mfaRequired } = useAuth();
  const { isLoading } = useAppContext();

  if (!authChecked || isLoading) {
    return <FullScreenLoader />;
  }

  console.info("PublicRoute user", user);
  console.info("PublicRoute mfaRequired", mfaRequired);

  if (!user) {
    return <Outlet />;
  }

  if (mfaRequired) {
    return <Navigate to="/auth/mfa" replace />;
  }

  console.info("PublicRoute redirecting to /welcome");

  return <Navigate to="/welcome" replace />;
};
export const MfaRoute: React.FC = () => {
  const { user, authChecked, mfaRequired } = useAuth();
  const { isLoading } = useAppContext();

  console.info("MfaRoute user", user);
  console.info("MfaRoute mfaRequired", mfaRequired);

  if (!authChecked || isLoading) {
    return <FullScreenLoader />;
  }

  if (!mfaRequired) {
    return <Navigate to="/welcome" replace />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
};
